import React from 'react';
import {GeoAuthLayout} from '../../layout';
import {LoginForm} from './LoginForm';
import {Stack, Box} from '@chakra-ui/layout';
import {useResponsive} from 'utils/useResponsive';
import {LoginLegend} from './LogInLegend';
import {useRecaptcha} from 'utils/recaptcha';
import {HtmlTitle} from 'components/HtmlTitle';
import {useTranslation} from 'modules/i18n';
import {Skeleton} from '@chakra-ui/skeleton';

// eslint-disable-next-line
export interface LoginPageProps {}

export const LoginPage: React.FC<LoginPageProps> = () => {
	const {recaptchaLoaded} = useRecaptcha();
	const {isMobile} = useResponsive();
	const {t} = useTranslation();
	return (
		<>
			<HtmlTitle label={t('auth.title.signIn')} />
			<GeoAuthLayout>
				<Skeleton isLoaded={recaptchaLoaded}>
					<Box padding={isMobile ? 1 : 5} w={isMobile ? '100%' : 550}>
						<Stack spacing={2} direction='column'>
							<LoginLegend />
							<LoginForm />
						</Stack>
					</Box>
				</Skeleton>
			</GeoAuthLayout>
		</>
	);
};
